<div
    *transloco="let t"
    [class]="'bazis-control ' + cssClassSizeControl"
    [ngClass]="{
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': isDisabled,
        'bazis-control--dirty': ngControl.control.dirty,
        'bazis-control--empty':
            emptyValues.indexOf(ngControl.control.value) > -1 ||
            (max > 1 && !ngControl.control.value?.length),
    }"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
        } as data"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <!-- TODO: check template -->
        <!--<ng-container *ngIf="fileIds.length; else tplNoFiles">-->
        <ng-container *ngIf="uploadingDict$ | async as uploading">
            <ng-template #tplAnyFileType>
                <div *ngFor="let fileId of fileIds; let fileIndex = index">
                    <div
                        class="bazis-control__field-group bh-margin-bottom-3x"
                        [class.bazis-control__field-group--disabled]="isDisabled"
                    >
                        <div class="bazis-control__field">
                            <!-- процесс загрузки -->
                            <ng-container *ngIf="uploading[fileId]">
                                <div
                                    class="bazis-file-inline"
                                    *ngIf="
                                        uploading[fileId].status === 'progress' ||
                                        uploading[fileId].status === 'start'
                                    "
                                >
                                    <bazis-badge
                                        color="danger"
                                        size="large"
                                    >
                                        {{ uploading[fileId].extension }}
                                    </bazis-badge>
                                    <span class="bazis-list bazis-list_short-info">
                                        <span class="bazis-item">
                                            <bazis-link
                                                borderStyle="none"
                                                class="bh-events-none"
                                            >
                                                <span class="bh-ellipsis">
                                                    {{ uploading[fileId].name }}
                                                </span>
                                            </bazis-link>
                                        </span>
                                        <span class="bazis-item">
                                            <span>
                                                {{ uploading[fileId].size | fileSize }}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </ng-container>

                            <!-- Загруженный существующий файл -->
                            <ng-container *ngIf="!uploading[fileId]">
                                <ng-container
                                    *ngIf="
                                        fileId | entity: 'uploadable.file_upload' | async as file
                                    "
                                >
                                    <bazis-file-inline
                                        class="bh-contents"
                                        [file]="file"
                                    ></bazis-file-inline>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="bazis-control__field-group__end">
                            <button
                                *ngIf="!isDisabled"
                                [hidden]="uploading[fileId]"
                                (click)="removeFile(fileIndex)"
                            >
                                <bazis-icon [name]="icons.trash"></bazis-icon>
                            </button>
                            <bazis-default-loader
                                *ngIf="
                                    uploading[fileId]?.status === 'progress' ||
                                    uploading[fileId]?.status === 'start'
                                "
                                centerX="10"
                                centerY="10"
                                radius="10"
                            ></bazis-default-loader>
                        </div>
                    </div>
                </div>
                <bazis-button
                    fill="outline"
                    color="action"
                    *ngIf="fileIds.length < max && !isDisabled"
                >
                    {{ t(buttonKey, buttonParams) }}
                    <input
                        type="file"
                        [attr.multiple]="max > 1"
                        (focus)="markAsTouched()"
                        (change)="addFiles($event)"
                    />
                </bazis-button>
            </ng-template>

            <div
                *ngIf="fileType === 'image'; else tplAnyFileType"
                class="bazis-input-file_photo__container"
            >
                <button
                    class="bazis-figure bazis-figure_btn"
                    color="action"
                    *ngIf="fileIds.length < max && !isDisabled"
                >
                    <bazis-icon
                        [name]="icons.addFile"
                        size="regular"
                    ></bazis-icon>
                    {{ t('form.title.inputFile.addPhoto') }}
                    <input
                        type="file"
                        [attr.multiple]="max > 1"
                        (focus)="markAsTouched()"
                        (change)="addFiles($event)"
                    />
                </button>
                <ng-container *ngFor="let fileId of fileIds; let fileIndex = index">
                    <!-- процесс загрузки -->
                    <div
                        class="bazis-figure"
                        *ngIf="
                            uploading[fileId]?.status === 'progress' ||
                            uploading[fileId]?.status === 'start'
                        "
                    >
                        <span class="bazis-text_reduced">{{ t('process.loading') }}</span>
                        <span class="bh-ellipsis bh-font-medium">
                            {{ uploading[fileId].name }}
                        </span>
                        <div class="bazis-percentage-bar bh-margin-top-4x">
                            <span
                                class="bazis-percentage-bar__part"
                                color="primary"
                                [style.width]="uploading[fileId].progress + '%'"
                            ></span>
                        </div>
                    </div>
                    <!-- Загруженный существующий файл -->
                    <ng-container *ngIf="!uploading[fileId]">
                        <ng-container
                            *ngIf="fileId | entity: 'uploadable.file_upload' | async as file"
                        >
                            <div class="bazis-figure">
                                <img
                                    [src]="file.$snapshot.file"
                                    [title]="file.$snapshot.name"
                                    [alt]="imgAlt ? imgAlt : file.$snapshot.name"
                                />
                                <button
                                    *ngIf="!isDisabled"
                                    class="bazis-figure__close"
                                    (click)="removeFile(fileIndex)"
                                >
                                    <bazis-icon
                                        [name]="icons.eraser"
                                        color="action"
                                        size="compact"
                                    ></bazis-icon>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
        <!--</ng-container>-->

        <ng-template #tplNoFiles>
            <span class="bazis-text_secondary">{{ t('form.title.inputFile.noFiles') }}</span>
        </ng-template>

        <div class="bazis-control__error">
            <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
        </div>

        <div class="bazis-control__note">
            <p *ngIf="noteKey">{{ t(noteKey, noteParams) }}</p>
            <p>
                {{ t('form.title.inputFile.allowedFormats') }}
                <ng-container
                    *ngFor="let allowedExtension of displayAllowedExtentions; let i = index"
                >
                    {{ (i > 0 ? ', ' : '') + allowedExtension }}
                </ng-container>
            </p>
        </div>
    </ng-container>
</div>
